import React, { useState, useEffect } from 'react';

import Header from 'components/ui/Header';
import ContactQuickAccess from 'components/ui/ContactQuickAccess';


import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import TrustElements from './components/TrustElements';
import ProjectShowcase from './components/ProjectShowcase';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const Homepage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('es');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'es';
    setCurrentLanguage(savedLanguage);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        <HeroSection currentLanguage={currentLanguage} />
        <ServicesOverview currentLanguage={currentLanguage} />
        <TrustElements currentLanguage={currentLanguage} />
        <TestimonialsCarousel currentLanguage={currentLanguage} />
        <ProjectShowcase currentLanguage={currentLanguage} />
        <ContactSection currentLanguage={currentLanguage} />
      </main>

      <Footer currentLanguage={currentLanguage} />
      <ContactQuickAccess />
    </div>
  );
};

export default Homepage;